<!-- CakeOrderForm 蛋糕 更多信息 cake-item -->

<template>
  <div class="cake mt5">
    <van-cell is-link style="padding: 10px 0" title="更多信息" @click="handleAttrbute" />

    <van-action-sheet v-model="show" title="更多信息" style="min-height:70vh">
      <div style="padding: 10px">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-image van-sku-header__img-wrap">
            <img :src="goodsDetail.img" class="van-image__img" style="object-fit: cover" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-header-item">
              <div style="font-size: 14px; color: #333">
                {{ goodsDetail.name }}
              </div>
            </div>
            <div class="van-sku-header-item"></div>
            <div class="van-sku-header-item" style="display: flex; justify-content: space-between">
              <div style="color: rgb(255, 135, 72)">
                {{ goodsDetail.price | money }}
              </div>
              <div>x{{ goodsDetail.count }}</div>
            </div>
          </div>
        </div>

        <div v-if="goodsDetail.cateCode.substring(0, 8) === '00030115'">
          <div class="attribute">
            <div class="title">蜡烛款式</div>
            <van-radio-group v-model="extInfo.type" direction="horizontal">
              <van-radio name="1">彩色蜡烛</van-radio>
              <van-radio name="2">数字蜡烛</van-radio>
            </van-radio-group>
          </div>
          <div v-if="extInfo.type === '2'" class="attribute">
            <div class="title">数字蜡烛</div>
            <van-field v-model="extInfo.candleNum" placeholder="请填写数字" type="digit" />
          </div>
          <div class="attribute">
            <div class="title">用餐人数</div>
            <van-field v-model="extInfo.count" placeholder="请填写数字" type="digit" />
          </div>
        </div>

        <div class="attribute">
          <div class="title">祝福话语</div>
          <van-field v-model="extInfo.blessing" placeholder="请填写留言" />
        </div>

        <div class="attribute">
          <div class="title">配送时间</div>
          <van-field v-model="extInfo.time" is-link placeholder="请选择送达时间" readonly @click="timeShow = true" />
          <van-popup v-model="timeShow" position="bottom" round :style="{ height: '64vh' }">
            <van-cascader v-model="extInfo.time2" :options="timeOptions" title="送达时间" @close="timeShow = false"
              @finish="onFinish" />
          </van-popup>
        </div>

        <div class="van-sku-actions" style="padding: 0; position: fixed; bottom: 10px; width: calc(100vw - 20px);">
          <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" round size="large" type="danger"
            @click="paySetup">支付订单</van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
const defaultExtInfo = {
  time: "",
  time2: "",
  count: "",
  blessing: "",
  type: "2",
  candleNum: "",
};

export default {
  name: "cake",

  props: {
    goodsDetail: { type: Object }
  },

  data() {
    return {
      show: false,
      timeShow: false,
      extInfo: JSON.parse(JSON.stringify(defaultExtInfo)),
      timeOptions: [],
    };
  },

  mounted() {
    this.init_option_0()
  },

  methods: {
    init_option_0() {
      let time = [
        { value: 1012, text: "10:00-12:00" },
        { value: 1214, text: "12:00-14:00" },
        { value: 1416, text: "14:00-16:00" },
        { value: 1618, text: "16:00-18:00" },
      ]

      this.timeOptions = [
        {
          text: this.getTime("明天"),
          value: "1",
          children: time,
        },
        {
          text: this.getTime("后天"),
          value: "2",
          children: time,
        },
        {
          text: this.getTime(""),
          value: "3",
          children: time,
        }
      ]
    },

    getTime(data) {
      let date = "";
      switch (data) {
        case "明天":
          date = new Date().setTime(new Date().getTime() + 24 * 60 * 60 * 1000);
          break;
        case "后天":
          date = new Date().setTime(new Date().getTime() + 48 * 60 * 60 * 1000);
          break;
        default:
          date = new Date().setTime(new Date().getTime() + 72 * 60 * 60 * 1000);
          break;
      }

      let m = new Date(date).getMonth() + 1;
      let d = new Date(date).getDate();
      let week = new Date(date).getDay();

      let weekArr = {
        明天: "明天",
        后天: "后天",
        0: "周日",
        1: "周一",
        2: "周二",
        3: "周三",
        4: "周四",
        5: "周五",
        6: "周六",
      };

      return `${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} (${data === "" ? weekArr[week] : weekArr[data]})`;
    },

    handleAttrbute() {
      this.extInfo = JSON.parse(JSON.stringify(defaultExtInfo));
      this.show = true;
    },

    onFinish({ selectedOptions }) {
      this.timeShow = false;
      this.extInfo.time = selectedOptions
        .map((option) => option.text)
        .join("/");
    },

    paySetup() {
      this.$emit("paySetup", this.extInfo)
    },
  },
};
</script>

<style lang="scss" scoped>
.attribute {
  display: flex;
  margin: 20px 0;

  .title {
    width: 100px;
  }

  .van-cell {
    padding: 0;
    flex: 1;
  }
}
</style>